module.exports = __webpack_public_path__ + "1a05dd515560addd261a993f2272d792.png";